import { connect } from 'react-redux';
import { dispatchify } from 'common/utils/utils';
import {
  toggleSnackBar,
  toggleModal,
  createSensorAuthorization,
  updateSensorAuthorization
} from 'state/callers';
import { myAccountSelector } from 'state/selectors/account';
import { repositoriesSelector } from 'state/selectors/repositories';
import SingleSignOnState from './SingleSignOn';

const mapStateToProps = state => ({
  repositories: repositoriesSelector(state),
  account: myAccountSelector(state)
});

const mapDispatchToProps = dispatch => ({
  ...dispatchify(dispatch, {
    toggleSnackBar,
    toggleModal,
    createSensorAuthorization,
    updateSensorAuthorization
  })
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleSignOnState);
